import { useContext, useEffect, useRef } from 'react';

import { FocusContext } from './FocusRestoreProvider.types';

export const useFocusRestoreManager = () => {
    const context = useContext(FocusContext);
    if (!context) {
        throw new Error('useFocusRestoreManager must be used within a FocusProvider');
    }
    return context;
};

export const useFocusRestore = <T extends HTMLElement>(key: string) => {
    const ref = useRef<T>(null);
    const { register, unregister, setFocused } = useFocusRestoreManager();

    useEffect(() => {
        register(key, ref);
        return () => unregister(key);
    }, [key, register, unregister]);

    return {
        ref,
        onFocus: () => setFocused(key),
    };
};
